<template>
    <card-box-small>
     <div>
         <h5 class="font-poppins font-weight-semibold color-blue mb-3">
             {{ Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.search_and_book.title') }}
         </h5>
         <ul class="ul-checked-list px-0 px-sm-1 font-weight-light color-dark-blue font-poppins mb-0">
             <li class="ml-md-0"
                 v-for="listValid in widgets.search_and_book.description_list_valid"
                 v-html="listValid"></li>
         </ul>
         <ul v-if="widgets.search_and_book.description_list_invalid"
             class="ul-invalid-list px-0 px-sm-1 font-weight-light color-dark-blue font-poppins">
             <li class="ml-md-0"
                 v-for="listInValid in widgets.search_and_book.description_list_invalid">
                 {{ listInValid }}
             </li>
         </ul>
         <div class="w-100 mt-3">
             <a :href="route('nl.employeedashboard.searchAndBook')"
                class="color-blue" style="text-decoration: underline; font-size: large">
                 {{ Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.search_and_book.see_more') }}
             </a>
         </div>
     </div>
    </card-box-small>
</template>
<script>
import CardBoxSmall from "../../../Shared/CardBoxSmall.vue";

export default {
    components: { CardBoxSmall },
    props: {
        widgets: Object,
    }
}
</script>
